import type { CauseCategoryId } from '../maintenance/downtime.seed';

/** [syn] Cause categories collapsed into Paul's Process/Equipment columns. */
export const SHIFT_CAUSE_GROUP: Readonly<Record<CauseCategoryId, 'process' | 'equipment'>> = {
  'pump-failures': 'equipment',
  'reagent-ph-upsets': 'process',
  'electrical-trips': 'equipment',
  'mill-crusher-mechanical': 'equipment',
  'cyclone-wear': 'equipment',
  'thickener-paste': 'equipment',
  'instrument-failures': 'equipment',
  'external-supply': 'process',
};
